import { getGtmId, trackPageView } from '@common/helpers/gtmEvents';
import { isTrackingHost } from '@common/helpers/tracking/hosts';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GTM_SCRIPT_ID = 'google-tag-manager';
const GTM_NOSCRIPT_ID = 'google-tag-manager-noscript';

export default function GoogleTagManager() {
  const location = useLocation();

  useEffect(() => {
    const gtmId = getGtmId();
    if (!gtmId || !isTrackingHost(window.location.hostname)) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': Date.now(),
      event: 'gtm.js',
    });

    if (!document.getElementById(GTM_SCRIPT_ID)) {
      const script = document.createElement('script');
      script.id = GTM_SCRIPT_ID;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      document.head.appendChild(script);
    }

    if (!document.getElementById(GTM_NOSCRIPT_ID)) {
      const noscript = document.createElement('noscript');
      noscript.id = GTM_NOSCRIPT_ID;

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';

      noscript.appendChild(iframe);
      document.body.prepend(noscript);
    }
  }, []);

  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
